import { propEq, update } from 'ramda';

import { types } from './actions';

const initialState = {
  activeEmailTemplateId: null,
  activeEmailTemplateType: null,
  defaultEmailTemplates: {},
  emailTemplates: [],
  isEmailTemplateDeleting: false, //should this be an array? i don't think i even use this...
  isEmailTemplateModalOpen: false,
  isEmailTemplateSaving: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.DELETE_EMAIL_TEMPLATE_ERROR:
      return {
        ...state,
        isEmailTemplateDeleting: false,
      };
    case types.DELETE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        isEmailTemplateDeleting: true,
      };
    case types.DELETE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        emailTemplates: state.emailTemplates.filter(
          ({ id }) => id !== payload.templateId,
        ),
        isEmailTemplateDeleting: false,
      };
    case types.EMAIL_TEMPLATE_MODAL_CLOSE:
      return {
        ...state,
        activeEmailTemplateId: null,
        activeEmailTemplateType: null,
        isEmailTemplateModalOpen: false,
      };
    case types.EMAIL_TEMPLATE_MODAL_OPEN:
      return {
        ...state,
        activeEmailTemplateId: payload.templateId,
        activeEmailTemplateType: payload.templateType,
        isEmailTemplateModalOpen: true,
      };

    case types.FETCH_DEFAULT_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        defaultEmailTemplates: payload.defaultEmailTemplates,
      };
    case types.FETCH_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        emailTemplates: payload.emailTemplates,
      };
    case types.UPDATE_OR_CREATE_EMAIL_TEMPLATE_ERROR:
      return {
        ...state,
        isEmailTemplateSaving: false,
      };
    case types.UPDATE_OR_CREATE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        isEmailTemplateSaving: true,
      };
    case types.UPDATE_OR_CREATE_EMAIL_TEMPLATE_SUCCESS: {
      const initialTemplates = state.emailTemplates;
      let templates = initialTemplates;
      if (payload.emailTemplate.isDefault) {
        templates = initialTemplates.map((t) =>
          t.templateType === payload.emailTemplate.templateType
            ? { ...t, isDefault: false }
            : t,
        );
      }
      const existingTemplateIndex = templates.findIndex(
        propEq('id', payload.emailTemplate.id),
      );
      return {
        ...state,
        activeEmailTemplateId: null,
        activeEmailTemplateType: null,
        emailTemplates:
          existingTemplateIndex >= 0
            ? update(existingTemplateIndex, payload.emailTemplate, templates)
            : [...templates, payload.emailTemplate],
        isEmailTemplateModalOpen: false,
        isEmailTemplateSaving: false,
      };
    }
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.digitalQuote.emailTemplates;

export const getCurrentActiveEmailTemplate = (state) => {
  const activeEmailTemplateId = getScope(state).activeEmailTemplateId;
  return (
    getScope(state).emailTemplates.find(
      ({ id }) => id == activeEmailTemplateId,
    ) || null
  );
};

export const getHasNoExistingTemplates = (state, type) => {
  const templates = getScope(state).emailTemplates;
  const filteredTemplates = templates.filter((t) => t.templateType === type);
  return filteredTemplates.length === 0;
};

export const getSelectedDefaultEmailTemplate = (state) => {
  const templates = getScope(state).emailTemplates;
  const templateType = getScope(state).activeEmailTemplateType;
  const defaultTemplate = templates.find(
    (t) => t.templateType === templateType && t.isDefault === true,
  );
  return defaultTemplate;
};

export const getDefaultEmailTemplate = (state) => {
  const activeEmailTemplateType = getScope(state).activeEmailTemplateType;
  return getScope(state).defaultEmailTemplates[activeEmailTemplateType];
};

export const getEmailTemplates = (state) => getScope(state).emailTemplates;

export const getIsEmailTemplateModalOpen = (state) =>
  getScope(state).isEmailTemplateModalOpen;

export const getIsEmailTemplateSaving = (state) =>
  getScope(state).isEmailTemplateSaving;

export const getEmailTemplateType = (state) =>
  getScope(state).activeEmailTemplateType;
